(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-colour-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  var button=event.target.closest('[data-card-colour]');
  if(!button)return;
  var card=button.closest('.product-card,.inline-related-card,.s7-product-card');
  if(!card)return;
  var image=card.querySelector('.product-card-media img,.inline-related-image img,.s7-product-card__media img');
  if(image&&button.dataset.image){image.removeAttribute('srcset');image.src=button.dataset.image;image.alt=button.dataset.imageAlt;}
  card.querySelectorAll('[data-card-colour]').forEach(function(swatch){swatch.setAttribute('aria-pressed',String(swatch===button));});
  var variantUrl=new URL(button.dataset.productUrl,window.location.origin);
  variantUrl.searchParams.set('variant',button.dataset.variantId);
  card.querySelectorAll('a').forEach(function(link){link.href=variantUrl.href;});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["s7-size-reminder"] && !Shopify.designMode) return;
  try {
    (function(){
  document.addEventListener('click',function(event){
    var button=event.target.closest('.option-picker--size [data-option-value]');
    if(!event.isTrusted||!button||button.disabled)return;
    var section=button.closest('[data-product-section]');
    var dialog=section&&section.querySelector('[data-size-reminder]');
    if(!dialog||typeof dialog.showModal!=='function'||dialog.open)return;
    dialog._sizeTrigger=button;
    dialog._viewChart=false;
    var chart=section.querySelector('.fit-guide');
    dialog.querySelector('[data-reminder-chart]').hidden=!chart;
    if(!dialog.dataset.reminderReady){
      dialog.dataset.reminderReady='true';
      dialog.querySelector('[data-reminder-close]').addEventListener('click',function(){dialog.close()});
      dialog.querySelector('[data-reminder-chart]').addEventListener('click',function(){
        var guide=section.querySelector('.fit-guide');
        if(!guide)return;
        dialog._viewChart=true;
        dialog.close();
        guide.open=true;
        var summary=guide.querySelector('summary');
        if(summary)summary.focus({preventScroll:true});
        guide.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      });
      dialog.addEventListener('close',function(){
        if(!dialog._viewChart&&dialog._sizeTrigger&&dialog._sizeTrigger.isConnected)dialog._sizeTrigger.focus({preventScroll:true});
      });
    }
    dialog.showModal();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
